function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var isFormMessageObject = function(messages) {
    return _instanceof(messages, Object);
};
export function normalizeMessages(messages) {
    var normalizedMessages = {};
    if (typeof messages === 'string') {
        normalizedMessages = {
            info: [
                messages
            ]
        };
    } else if (Array.isArray(messages)) {
        normalizedMessages = {
            info: messages
        };
    } else if (isFormMessageObject(messages)) {
        normalizedMessages = messages;
    }
    return normalizedMessages;
}
export default normalizeMessages;
